(() => {
  let tooltip = null;
  let activeTrigger = null;

  function ensureTooltip() {
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'global-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      document.body.appendChild(tooltip);
    }
  }

  function show(trigger) {
    const root = trigger.closest('[data-tooltip-root]');
    const template = root.querySelector('.help-template');
    if (!template) return;

    ensureTooltip();
    tooltip.innerHTML = template.innerHTML;

    const rect = trigger.getBoundingClientRect();
    tooltip.style.left = rect.left + rect.width / 2 + 'px';
    tooltip.style.top = rect.bottom + 8 + 'px';
    tooltip.style.transform = 'translate(-50%, 0)';

    tooltip.classList.add('visible');
    trigger.setAttribute('aria-expanded', 'true');
    activeTrigger = trigger;
  }
  
  function hide() {
    if (!tooltip) return;
    tooltip.classList.remove('visible');
    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger = null;
    }
  }

document.addEventListener('click', e => {
    const trigger = e.target.closest('.help-trigger');
    if (trigger) {
        e.preventDefault();
        e.stopPropagation();
    }
    if (!trigger) {
        hide();
        return;
    }
    if (activeTrigger === trigger) {
        hide();
    } else {
        hide();
        show(trigger);
    }
});

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') hide();
  });

  window.addEventListener('scroll', hide, { passive: true });
})();
